<script>
import DatePicker from "vue2-datepicker"; // add DatePicker
import { required, minLength, maxLength } from "vuelidate/lib/validators";
import certificate from '../../../helpers/list/certificate';
import marital_status from '../../../helpers/list/marital_status';
import nationalism from '../../../helpers/list/nationalism';
import religion from '../../../helpers/list/religion';

export default {
  components: { DatePicker },
  props: {
    sacrificer: {
      type: Object,
      default(){
        return null
      }
    }
  },

  data() {
    return {
      birth_date: "",
      phone1: "",
      phone2: "",
      national_id_number: "",
      nationality_number: "",
      marital_status_id: "",
      certificate_id: "",
      father_alive: "",
      mother_alive: "",
      retirement_number: "",
      number_children: "",
      religion_id: "",
      nationalism_id: "",

      //lists
      list_certificate: certificate,
      list_marital_status: marital_status,
      list_nationalism: nationalism,
      list_religion: religion,
    };
  },
  validations: {
    birth_date: { required },
    number_children: {
      required,
      minLength: minLength(1),
      maxLength: maxLength(2),
    },
    religion_id: { required },
    nationalism_id: { required },
    marital_status_id: { required },
    certificate_id: { required },
    father_alive: { required },
    mother_alive: { required },
    retirement_number: {
      required,
      minLength: minLength(6),
      maxLength: maxLength(10),
    },
    form: [
      "birth_date",
      "marital_status_id",
      "certificate_id",
      "father_alive",
      "mother_alive",
      "retirement_number",
      "number_children",
      "religion_id",
      "nationalism_id",
    ],
  },
  methods: {
    // validate
    validate() {
      this.$v.form.$touch();
      var isValid = !this.$v.form.$invalid;
      this.$emit("on-validate", this.$data, isValid);
      return isValid;
    },
  },
};
</script>

<template>
  <!-- start page title -->
  <div>
    <!-- شهيد -->
    <div class="row">
      <!-- modal info -->
      <div class="col-md-12">
        <div class="about-info">
          <i class="bx bx-left-arrow-circle bx-fade-left"></i>
          <a href="javascript: void(0);" v-b-modal.modal-info class="text-dark"
            >قراءة التعليمات</a
          >
        </div>
      </div>
      <b-modal
        id="modal-info"
        size="md"
        title="قراءة التعليمات"
        title-class="font-18"
        hide-footer
      >
        <h5 class="mb-2">تعليمات ملء استمارة قطع الاراضي والبدل النقدي " للشهيد " .</h5>
        <ul class="li-info">
          <li>الدقة في ملء بيانات الاستمارة .</li>
          <li>
            عند رفع المرفقات في الحقول المخصصة للمرفقات يجب ان تكون بصيغة ( pdf. ) وبحجم
            لا يتجاوز ( 2mb ) .
          </li>
          <li>
            عند اضافة المستفيدين يجب ذكر المستفيدين المذكورين في القسام الشرعي حصرا .
          </li>
          <li>
            اذا كنت مستلم لقطعة ارض او اكثر يجب ذكرها ليتم تسجيلك على (منحة البناء) للارض
            .
          </li>
          <li>
            اذا كنت مستلم جزء من (البدل النقدي) لقطعة الارض يجب ذكر المبلغ المستلم ليتم
            تسجيلك على اكمال باقي البدل النقدي .
          </li>
          <li>
            اذا كنت مستلم جزء من (منحة البناء) يجب ذكر المبلغ المستلم ليتم تسجيلك على
            اكمال باقي منحة البناء .
          </li>
        </ul>
      </b-modal>
      <!-- title -->
      <hr class="hr-title" />
      <div class="break-title"><h5 class="mb-4">البيانات الشخصية للشهيد</h5></div>
      <b-form-group class="col-md-3 mb-3" label="الاسم : " label-for="name1">
        <b-form-input
          id="name1"
          type="text"
          placeholder="ادخل الاسم"
          v-model="sacrificer.sacrificer.name1"
          :disabled="true"
        ></b-form-input>
      </b-form-group>
      <b-form-group class="col-md-3 mb-3" label="اسم الاب : " label-for="name2">
        <b-form-input
          id="name2"
          type="text"
          placeholder="ادخل اسم الاب"
          v-model="sacrificer.sacrificer.name2"
          :disabled="true"
        ></b-form-input>
      </b-form-group>
      <b-form-group class="col-md-3 mb-3" label="اسم الجد : " label-for="name3">
        <b-form-input
          id="name3"
          type="text"
          placeholder="ادخل اسم الجد"
          v-model="sacrificer.sacrificer.name3"
          :disabled="true"
        ></b-form-input>
      </b-form-group>
      <b-form-group class="col-md-3 mb-3" label="اسم اب الجد : " label-for="name4">
        <b-form-input
          id="name4"
          type="text"
          placeholder="ادخل اسم اب الجد"
          v-model="sacrificer.sacrificer.name4"
          :disabled="true"
        ></b-form-input>
      </b-form-group>
    </div>
    <div class="row">
      <b-form-group class="col-md-6 mb-3" label=" اللقب : " label-for="family_name">
        <b-form-input
          id="family_name"
          type="text"
          placeholder="ادخل اللقب"
          v-model="sacrificer.sacrificer.family_name"
          :disabled="true"
        ></b-form-input>
      </b-form-group>
      <b-form-group
        class="col-md-6 mb-3"
        label="اسم الام الثلاثي : "
        label-for="mother_name"
      >
        <b-form-input
          id="mother_name"
          type="text"
          placeholder="ادخل اسم الام الثلاثي"
          v-model="sacrificer.sacrificer.mother_name"
          :disabled="true"
        ></b-form-input>
      </b-form-group>
    </div>
    <div class="row">
      <b-form-group class="col-md-4 mb-3" label="تاريخ التولد : " label-for="birth_date">
        <date-picker
          id="birth_date"
          type="date"
          lang="ar"
          value-type="DD-MM-YYYY"
          format="DD-MM-YYYY"
          placeholder="اختر تاريخ التولد"
          v-model="birth_date"
          :class="{ 'is-invalid': $v.birth_date.$error }"
        ></date-picker>
        <div v-if="$v.birth_date.$error" class="invalid-feedback">
          <span v-if="!$v.birth_date.required">هذا الحقل الزامي</span>
        </div>
      </b-form-group>
      <b-form-group
        class="col-md-4 mb-3"
        label=" الحالة الاجتماعية : "
        label-for="marital_status_id"
      >
        <select
          class="form-control"
          id="marital_status_id"
          v-model="marital_status_id"
          :class="{ 'is-invalid': $v.marital_status_id.$error }"
        >
          <option value="">اختر الحالة الاجتماعية</option>
          <option v-for="marital_status in list_marital_status" :value="marital_status.id" :key="marital_status.id">{{marital_status.name}}</option>
        </select>
        <div v-if="$v.marital_status_id.$error" class="invalid-feedback">
          <span v-if="!$v.marital_status_id.required">هذا الحقل الزامي</span>
        </div>
      </b-form-group>
      <b-form-group
        class="col-md-4 mb-3"
        label=" عدد الابناء : "
        label-for="number_children"
      >
        <b-form-input
          id="number_children"
          type="number"
          placeholder="ادخل عدد الابناء "
          v-model="number_children"
          :class="{ 'is-invalid': $v.number_children.$error }"
        ></b-form-input>
        <div v-if="$v.number_children.$error" class="invalid-feedback">
          <span v-if="!$v.number_children.required">هذا الحقل الزامي</span>
          <span v-if="!$v.number_children.minLength"
            >يجب أن يتكون عدد الابناء من رقم واحد على الأقل</span
          >
          <span v-if="!$v.number_children.maxLength"
            >يجب أن يتكون عدد الابناء من رقمين على الاكثر</span
          >
        </div>
      </b-form-group>
    </div>
    <div class="row">
      <b-form-group
        class="col-md-6 mb-3"
        label=" التحصيل الدراسي : "
        label-for="certificate_id"
      >
        <select
          class="form-control"
          id="certificate_id"
          v-model="certificate_id"
          :class="{ 'is-invalid': $v.certificate_id.$error }"
        >
          <option value="">اختر التحصيل الدراسي</option>
          <option v-for="certificate in list_certificate" :value="certificate.id" :key="certificate.id">{{certificate.name}}</option>
        </select>
        <div v-if="$v.certificate_id.$error" class="invalid-feedback">
          <span v-if="!$v.certificate_id.required">هذا الحقل الزامي</span>
        </div>
      </b-form-group>
      <b-form-group
        class="col-md-6 mb-3"
        label=" الرقم التقاعدي : "
        label-for="retirement_number"
      >
        <b-form-input
          id="retirement_number"
          type="number"
          placeholder="ادخل الرقم التقاعدي"
          v-model="retirement_number"
          :class="{ 'is-invalid': $v.retirement_number.$error }"
        ></b-form-input>
        <div v-if="$v.retirement_number.$error" class="invalid-feedback">
          <span v-if="!$v.retirement_number.required">هذا الحقل الزامي</span>
          <span v-if="!$v.retirement_number.minLength"
            >يجب أن يتكون الرقم التقاعدي من 6 ارقام على الأقل</span
          >
          <span v-if="!$v.retirement_number.maxLength"
            >يجب أن يتكون الرقم التقاعدي من 10 ارقام على الاكثر</span
          >
        </div>
      </b-form-group>
    </div>
    <div class="row">
      <b-form-group
        class="col-md-6 mb-3"
        label=" هل الاب على قيد الحياة : "
        label-for="father_alive"
      >
        <select
          class="form-control"
          id="father_alive"
          v-model="father_alive"
          :class="{ 'is-invalid': $v.father_alive.$error }"
        >
          <option value="">اختر الاجابة</option>
          <option value="1">نعم</option>
          <option value="0">لا</option>
        </select>
        <div v-if="$v.father_alive.$error" class="invalid-feedback">
          <span v-if="!$v.father_alive.required">هذا الحقل الزامي</span>
        </div>
      </b-form-group>
      <b-form-group
        class="col-md-6 mb-3"
        label=" هل الام على قيد الحياة : "
        label-for="mother_alive"
      >
        <select
          class="form-control"
          id="mother_alive"
          v-model="mother_alive"
          :class="{ 'is-invalid': $v.mother_alive.$error }"
        >
          <option value="">اختر الاجابة</option>
          <option value="1">نعم</option>
          <option value="0">لا</option>
        </select>
        <div v-if="$v.mother_alive.$error" class="invalid-feedback">
          <span v-if="!$v.mother_alive.required">هذا الحقل الزامي</span>
        </div>
      </b-form-group>
    </div>
    <div class="row">
      <b-form-group class="col-md-6 mb-3" label=" الديانة : " label-for="religion_id">
        <select
          class="form-control"
          id="religion_id"
          v-model="religion_id"
          :class="{ 'is-invalid': $v.religion_id.$error }"
        >
          <option value="">اختر الديانة</option>
          <option v-for="religion in list_religion" :value="religion.id" :key="religion.id">{{religion.name}}</option>
        </select>
        <div v-if="$v.religion_id.$error" class="invalid-feedback">
          <span v-if="!$v.religion_id.required">هذا الحقل الزامي</span>
        </div>
      </b-form-group>
      <b-form-group class="col-md-6 mb-3" label=" القومية : " label-for="nationalism_id">
        <select
          class="form-control"
          id="nationalism_id"
          v-model="nationalism_id"
          :class="{ 'is-invalid': $v.nationalism_id.$error }"
        >
          <option value="">اختر القومية</option>
          <option v-for="nationalism in list_nationalism" :value="nationalism.id" :key="nationalism.id">{{nationalism.name}}</option>
        </select>
        <div v-if="$v.nationalism_id.$error" class="invalid-feedback">
          <span v-if="!$v.nationalism_id.required">هذا الحقل الزامي</span>
        </div>
      </b-form-group>
    </div>
  </div>
  <!-- end page title -->
</template>
